module.exports = __webpack_public_path__ + "img/question.de7de10d.svg";